export default __webpack_public_path__ + "static/media/Venturer's Armguards of Stalking Fury.2e5fc6e8.jpg";